<div class="main-content ajustes-page">
  <div class="container-fluid">
    <section class="ajustes-hero">
      <div class="ajustes-hero__identity">
        <div class="ajustes-avatar">
          <img [src]="fotoajustes" id="wizardPicturePreview" alt="Foto de perfil" />
          <label class="ajustes-avatar__action" for="profile-picture">
            <i class="material-icons">photo_camera</i>
          </label>
          <input type="file" id="profile-picture" (change)="onFileChanged($event)" accept="image/*" />
        </div>

        <div class="ajustes-hero__content">
          <h1>{{ pNombre || "Perfil de usuario" }}</h1>
          <p class="ajustes-hero__role">{{ puestoActual }}</p>

          <div class="ajustes-hero__meta">
            <span class="ajustes-chip ajustes-chip--success">Activo</span>
            <span class="ajustes-hero__meta-text">{{ areaActual }}</span>
            <span class="ajustes-hero__meta-text">{{ nombreusuario }}</span>
          </div>
        </div>
      </div>

      <button type="button" mat-raised-button class="btn ajustes-primary-btn" (click)="editemail()">
        Editar Perfil
      </button>
    </section>

    <div class="row ajustes-layout">
      <div class="col-12 col-xl-8">
        <section class="ajustes-card">
          <div class="ajustes-card__header">
            <div class="ajustes-card__title">
              <i class="material-icons">person_outline</i>
              <span>Información Personal</span>
            </div>
          </div>

          <div class="ajustes-card__body ajustes-data-grid">
            <div class="ajustes-data-item">
              <span class="ajustes-data-item__label">Nombre completo</span>
              <strong>{{ pNombre || "Sin información" }}</strong>
            </div>

            <div class="ajustes-data-item">
              <span class="ajustes-data-item__label">Correo electrónico</span>
              <strong class="text-break-usuario">{{ correoelectronico || "Sin información" }}</strong>
            </div>

            <div class="ajustes-data-item">
              <span class="ajustes-data-item__label">Nombre de usuario</span>
              <strong>{{ nombreusuario || "Sin información" }}</strong>
            </div>

            <div class="ajustes-data-item">
              <span class="ajustes-data-item__label">Puesto</span>
              <strong>{{ puestoActual }}</strong>
            </div>
          </div>
        </section>

        <section class="ajustes-card ajustes-card--apariencia">
          <div class="ajustes-card__header">
            <div class="ajustes-card__title">
              <i class="material-icons">palette</i>
              <span>Apariencia</span>
            </div>
          </div>

          <div class="ajustes-card__body">
            <p class="ajustes-card__hint">
              Elige el modo y el estilo visual del Centro Operativo. Se guarda en este navegador y aplica en el acto.
            </p>
            <app-selector-tema vista="tarjetas"></app-selector-tema>
          </div>
        </section>

        <section class="ajustes-card ajustes-card--tokens">
          <div class="ajustes-card__header">
            <div class="ajustes-card__title">
              <i class="material-icons">sync_alt</i>
              <span>Tokens de Integración</span>
            </div>
            <button type="button" mat-raised-button class="btn ajustes-primary-btn ajustes-primary-btn--compact"
              (click)="edittoken()">
              Administrar Tokens
            </button>
          </div>

          <div class="ajustes-card__body ajustes-token-list">
            <article class="ajustes-token-item">
              <div class="ajustes-token-item__icon ajustes-token-item__icon--gitlab">
                <i class="material-icons">code</i>
              </div>

              <div class="ajustes-token-item__copy">
                <strong>GitLab Personal Access Token</strong>
                <span>{{ gitConfigurado ? "Token configurado correctamente" : "Token pendiente de captura" }}</span>
              </div>

              <div class="ajustes-token-item__meta">
                <span class="ajustes-token-item__preview">{{ gitTokenPreview }}</span>
                <span class="ajustes-token-item__status" [class.is-ok]="gitConfigurado">
                  {{ gitSet }}
                </span>
              </div>
            </article>

            <article class="ajustes-token-item">
              <div class="ajustes-token-item__icon ajustes-token-item__icon--azure">
                <i class="material-icons">cloud_done</i>
              </div>

              <div class="ajustes-token-item__copy">
                <strong>Azure DevOps PAT</strong>
                <span>{{ azureConfigurado ? "Token configurado correctamente" : "Token pendiente de captura" }}</span>
              </div>

              <div class="ajustes-token-item__meta">
                <span class="ajustes-token-item__preview">{{ azureTokenPreview }}</span>
                <span class="ajustes-token-item__status" [class.is-ok]="azureConfigurado">
                  {{ azureSet }}
                </span>
              </div>
            </article>
          </div>
        </section>
      </div>

      <div class="col-12 col-xl-4">
        <section class="ajustes-card ajustes-card--integracion">
          <div class="ajustes-card__header">
            <div class="ajustes-card__title">
              <i class="material-icons">hub</i>
              <span>Estado de Integración</span>
            </div>
          </div>

          <div class="ajustes-card__body">
            <div class="ajustes-status-list">
              <div class="ajustes-status-item">
                <div class="ajustes-status-item__info">
                  <span class="ajustes-status-item__dot" [class.is-ok]="gitConfigurado"></span>
                  <span>GitLab API</span>
                </div>
                <span class="ajustes-inline-badge" [class.is-ok]="gitConfigurado">{{ gitSet }}</span>
              </div>

              <div class="ajustes-status-item">
                <div class="ajustes-status-item__info">
                  <span class="ajustes-status-item__dot" [class.is-ok]="azureConfigurado"></span>
                  <span>Azure Boards</span>
                </div>
                <span class="ajustes-inline-badge" [class.is-ok]="azureConfigurado">{{ azureSet }}</span>
              </div>

              <div class="ajustes-status-item ajustes-status-item--toggle">
                <div class="ajustes-status-item__info">
                  <span class="ajustes-status-item__dot" [class.is-ok]="recibirCorreo"></span>
                  <span>Recibir correo de inicio de actividades</span>
                </div>

                <div class="ajustes-status-item__action">
                  <span class="ajustes-inline-badge" [class.is-ok]="recibirCorreo">
                    {{ recibirCorreo ? "Activo" : "Inactivo" }}
                  </span>
                  <mat-slide-toggle [(ngModel)]="recibirCorreo" (change)="actulizarEstatusEnvioCorreo($event)">
                  </mat-slide-toggle>
                </div>
              </div>
            </div>

          </div>
        </section>

        <section class="ajustes-card ajustes-card--seguridad">
          <div class="ajustes-card__header">
            <div class="ajustes-card__title">
              <i class="material-icons">shield</i>
              <span>Seguridad de la Cuenta</span>
            </div>
          </div>

          <div class="ajustes-card__body">
            <div class="ajustes-security-panel">
              <div class="ajustes-security-panel__header">
                <div class="ajustes-security-panel__icon">
                  <i class="material-icons">lock_outline</i>
                </div>

                <div class="ajustes-security-panel__copy">
                  <strong>Contraseña</strong>
                  <span>Gestiona el acceso principal a tu cuenta</span>
                </div>
              </div>

              <div class="ajustes-security-panel__mask">••••••••••••••••</div>

              <button type="button" mat-raised-button class="btn ajustes-primary-btn ajustes-primary-btn--full"
                (click)="editpassword()">
                Cambiar Contraseña
              </button>
            </div>

            <!-- Solo aparece si el perfil autoriza con PIN, o si ya tiene uno -->
            <app-pin-autorizador-panel></app-pin-autorizador-panel>
          </div>
        </section>
      </div>
    </div>
  </div>
</div>
